import { VBtn, VCard, VCol, VRow, VIcon } from "vuetify/lib";
import DataList from "../components/DataList";
import { devStages, SPU_TYPE } from "../constants";
import DevStageModal from "./DevStageModal";
import SpuDevStage from "./SpuDevStage";
import { getSpuDetail } from "../service";
import { mapGetters } from "vuex";
// import UserFlow from "@/views/components/flow/user_flow.vue";
import UserFlowBase from "@/views/components/flow/user_flow_base_jsx_v1";

export default {
  props: {
    spuId: {
      type: Number,
    },
    rt: {
      type: Number,
    },
  },
  data() {
    const typeHash = {}
    SPU_TYPE.forEach(type => {
      typeHash[type.value] = type.label
    });
    console.log(typeHash)
    return {
      loading: true,
      devStageFields: [...devStages[2].fields],
      detail: {},
      devBfileKey: devStages[1].bfileKey,
      typeHash: typeHash
    };
  },
  computed: {
    ...mapGetters({
      teams_hash: "async/root_teams_hash",
    }),
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    canApply() {
      const current_hash = this.$store.state.hash_authority || {};
      return current_hash["spu_apply"];
    },
    haveApplyAuthority() {
      return this.cur_customer.id === this.detail.customer_id || this.canApply;
    },
  },
  watch: {
    rt() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      getSpuDetail({ id: this.spuId }).then((res) => {
        this.detail = res;
        console.log(res);
        this.loading = false;
      });
    },
    edit(params) {
      // this.$refs.edit.edit({ marketStart: null, marketEnd: null });
      this.$refs.edit.edit(params);
    },
  },
  render() {
    return (
      <div style="padding: 2px 0;">
        <VCard
          loading={this.loading}
          disabled={this.loading}
          style="padding: 20px;"
        >
          <VRow>
            <VCol style="font-weight: bold;">基本信息</VCol>
          </VRow>
          <VRow>
            <VCol offset={1} style={{ lineHeight: "2em" }}>
              <div>SPU编号：{this.detail.uid}{this.detail.tail_num}</div>
              <div>SPU：{this.detail.spu_name}</div>
              <div>PF：{this.detail.product_family}</div>
              <div>Business Unit：{this.detail.business_unit}</div>
            </VCol>
            <VCol style={{ lineHeight: "2em" }}>
              <div>所属赛道：{this.detail.track}</div>
              <div>
                研发团队：
                {this.teams_hash[this.detail.research_team_id]
                  ? this.teams_hash[this.detail.research_team_id].name
                  : ""}
              </div>
              <div>
                市营销团队：
                {this.teams_hash[this.detail.sale_team_id]
                  ? this.teams_hash[this.detail.sale_team_id].name
                  : ""}
              </div>
              <div>
                类型：
                {this.typeHash[this.detail.type] || "-"}
              </div>
            </VCol>
            <VCol style={{ lineHeight: "2em" }}>
              <div>申请人：{this.detail.customer_name}</div>
              <div>
                项目组：
                {this.teams_hash[this.detail.team_id]
                  ? this.teams_hash[this.detail.team_id].name
                  : ""}
              </div>
              <div>备注：{this.detail.remark}</div>
            </VCol>
          </VRow>
          <div
            style={{ display: "flex", alignItems: "center", margin: "20px 0" }}
          >
            <div style="font-weight: bold;margin-right: 20px;">研发周期</div>
            {(this.cur_customer.id === this.detail.customer_id ||
              this.canApply) && (
              <div>
                {this.detail.sub_status === "need_approve" &&
                  !this.detail.cya_spu_approve && (
                    <VBtn
                      color="primary"
                      onClick={() => {
                        this.devStageFields = [...devStages[1].fields];
                        this.devBfileKey = devStages[1].bfileKey;
                        this.edit({
                          launch_begin_at: this.detail.launch_begin_at || null,
                          launch_end_at: this.detail.launch_end_at || null,
                          review_begin_at: this.detail.review_begin_at || null,
                          review_end_at: this.detail.review_end_at || null,
                          bfiles: [],
                        });
                      }}
                    >
                      申请立项
                    </VBtn>
                  )}
                {this.detail.sub_status === "approved" &&
                  !this.detail.cya_spu_review && (
                    <VBtn
                      color="primary"
                      onClick={() => {
                        this.devStageFields = [...devStages[2].fields];
                        this.devBfileKey = devStages[2].bfileKey;
                        const params = {
                          launch_begin_at: null,
                          launch_end_at: null,
                          bfiles: [],
                        };
                        if (this.detail.cya_spu_approve) {
                          const prev = this.detail.cya_spu_approve;
                          params.conclusion = prev.conclusion;
                          params.budget_amount = prev.budget_amount;
                          params.launch_begin_at = prev.launch_begin_at;
                          params.launch_end_at = prev.launch_end_at;
                        }
                        this.edit(params);
                      }}
                    >
                      申请典型课评审
                    </VBtn>
                  )}
                {this.detail.sub_status === "reviewed" &&
                  !this.detail.cya_spu_launch && (
                    <VBtn
                      color="primary"
                      onClick={() => {
                        this.devStageFields = [...devStages[3].fields];
                        this.devBfileKey = devStages[3].bfileKey;
                        const params = {
                          launch_begin_at: "",
                          bfiles: [],
                        };
                        if (this.detail.cya_spu_review) {
                          const prev = this.detail.cya_spu_review;
                          params.conclusion = prev.conclusion;
                          params.budget_amount = prev.budget_amount;
                          params.launch_begin_at = prev.launch_begin_at || "";
                        }
                        this.edit(params);
                      }}
                    >
                      申请上市
                    </VBtn>
                  )}
              </div>
            )}
          </div>
          {!this.loading && this.detail && (
            <VRow>
              <VCol>
                <SpuDevStage
                  status="finished"
                  scopedSlots={{
                    title: () => {
                      return <span>待立项</span>;
                    },
                    content: () => {
                      return (
                        <DataList
                          fields={devStages[0].fields}
                          data={this.detail}
                        />
                      );
                    },
                  }}
                ></SpuDevStage>
              </VCol>
              <VCol>
                <SpuDevStage
                  status={
                    this.detail && this.detail.status !== "researching"
                      ? "finished"
                      : this.detail.sub_status === "need_approve"
                      ? "pending"
                      : "finished"
                  }
                  scopedSlots={{
                    title: () => {
                      return (
                        <span>
                          立项结论
                          {this.detail.status === "researching" &&
                            this.detail.sub_status === "need_approve" &&
                            this.detail.cya_spu_approve &&
                            this.haveApplyAuthority && (
                              <VIcon
                                color={"white"}
                                style="cursor: pointer; "
                                on={{
                                  click: () => {
                                    this.devStageFields = [
                                      ...devStages[1].fields,
                                    ];
                                    this.devBfileKey = devStages[1].bfileKey;
                                    this.edit(this.detail.cya_spu_approve);
                                  },
                                }}
                              >
                                mdi-circle-edit-outline
                              </VIcon>
                            )}
                        </span>
                      );
                    },
                    content: () => {
                      return (
                        <div>
                          <DataList
                            fields={devStages[1].fields}
                            data={
                              this.detail && this.detail.cya_spu_approve
                                ? this.detail.cya_spu_approve
                                : {}
                            }
                          />
                          {this.detail.cya_spu_approve &&
                            this.detail.cya_spu_approve.user_flow && (
                              <div style="display: flex;">
                                <div style="padding-right: 10px; text-align: right; line-height: 1.5rem; width: 45%; flex: 0 0 45%;">
                                  审批流程
                                </div>
                                <div style="padding-left: 10px; text-align: left; line-height: 1.5rem; width: 55%; flex: 0 0 55%;">
                                  <UserFlowBase
                                    user_flow={
                                      this.detail.cya_spu_approve.user_flow ||
                                      {}
                                    }
                                    modelC={
                                      this.detail.cya_spu_approve.user_flow ||
                                      {}
                                    }
                                    on={{
                                      ["on-change"]: () => {
                                        this.init();
                                        this.$emit("refresh");
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      );
                    },
                  }}
                ></SpuDevStage>
              </VCol>
              <VCol>
                <SpuDevStage
                  status={
                    this.detail && this.detail.status !== "researching"
                      ? "finished"
                      : this.detail.sub_status === "need_approve"
                      ? "rest"
                      : this.detail.sub_status === "approved"
                      ? "pending"
                      : "finished"
                  }
                  scopedSlots={{
                    title: () => {
                      return (
                        <span>
                          典型课评审结论
                          {this.detail &&
                            this.detail.status === "researching" &&
                            this.detail.sub_status === "approved" &&
                            this.detail.cya_spu_review &&
                            this.haveApplyAuthority && (
                              <VIcon
                                color={"white"}
                                style="cursor: pointer; "
                                onClick={() => {
                                  this.devStageFields = [
                                    ...devStages[2].fields,
                                  ];
                                  this.devBfileKey = devStages[2].bfileKey;
                                  this.edit(this.detail.cya_spu_review);
                                }}
                              >
                                mdi-circle-edit-outline
                              </VIcon>
                            )}
                        </span>
                      );
                    },
                    content: () => {
                      return (
                        <div>
                          <DataList
                            fields={devStages[2].fields}
                            data={
                              this.detail && this.detail.cya_spu_review
                                ? this.detail.cya_spu_review
                                : {}
                            }
                          />
                          {this.detail.cya_spu_review &&
                            this.detail.cya_spu_review.user_flow && (
                              <div style="display: flex;">
                                <div style="padding-right: 10px; text-align: right; line-height: 1.5rem; width: 45%; flex: 0 0 45%;">
                                  审批流程
                                </div>
                                <div style="padding-left: 10px; text-align: left; line-height: 1.5rem; width: 55%; flex: 0 0 55%;">
                                  <UserFlowBase
                                    user_flow={
                                      this.detail.cya_spu_review.user_flow || {}
                                    }
                                    modelC={
                                      this.detail.cya_spu_review.user_flow || {}
                                    }
                                    on={{
                                      ["on-change"]: () => {
                                        this.init();
                                        this.$emit("refresh");
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      );
                    },
                  }}
                ></SpuDevStage>
              </VCol>
              <VCol>
                <SpuDevStage
                  status={
                    this.detail && this.detail.status !== "researching"
                      ? "finished"
                      : this.detail.sub_status === "need_approve"
                      ? "rest"
                      : this.detail.sub_status === "approved"
                      ? "rest"
                      : this.detail.sub_status === "reviewed"
                      ? "pending"
                      : "finished"
                  }
                  scopedSlots={{
                    title: () => {
                      return (
                        <span>
                          上市结论
                          {this.detail &&
                            this.detail.status === "researching" &&
                            this.detail.sub_status === "reviewed" &&
                            this.detail.cya_spu_launch &&
                            this.haveApplyAuthority && (
                              <VIcon
                                color={"white"}
                                style="cursor: pointer; "
                                onClick={() => {
                                  this.devStageFields = [
                                    ...devStages[3].fields,
                                  ];
                                  this.devBfileKey = devStages[3].bfileKey;
                                  this.edit(this.detail.cya_spu_launch);
                                }}
                              >
                                mdi-circle-edit-outline
                              </VIcon>
                            )}
                        </span>
                      );
                    },
                    content: () => {
                      return (
                        <div>
                          <DataList
                            fields={devStages[3].fields}
                            data={
                              this.detail && this.detail.cya_spu_launch
                                ? this.detail.cya_spu_launch
                                : {}
                            }
                          />
                          {this.detail.cya_spu_launch &&
                            this.detail.cya_spu_launch.user_flow && (
                              <div style="display: flex;">
                                <div style="padding-right: 10px; text-align: right; line-height: 1.5rem; width: 45%; flex: 0 0 45%;">
                                  审批流程
                                </div>
                                <div style="padding-left: 10px; text-align: left; line-height: 1.5rem; width: 55%; flex: 0 0 55%;">
                                  <UserFlowBase
                                    user_flow={
                                      this.detail.cya_spu_launch.user_flow || {}
                                    }
                                    modelC={
                                      this.detail.cya_spu_launch.user_flow || {}
                                    }
                                    on={{
                                      ["on-change"]: () => {
                                        this.init();
                                        this.$emit("refresh");
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      );
                    },
                  }}
                ></SpuDevStage>
              </VCol>
            </VRow>
          )}
        </VCard>
        <DevStageModal
          ref="edit"
          baseInforFields={this.devStageFields}
          bfileKey={this.devBfileKey}
          spuId={this.spuId}
          on={{
            submit: () => {
              this.init();
              this.$emit("refresh");
            },
          }}
        />
      </div>
    );
  },
};
